import { message, PageHeader, Spin, Upload, Row, Col } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import axios from 'axios'
import {
  Form,
  FormItem,
  TableItem,
  ButtonItem,
} from "../../../../Components/Items";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from 'xlsx'
import ModalProgreso from "../../../../Components/ModalProgreso";
import SeguidorProcesoMasivo from "../../../../Components/seguirProcesoMasivo";

class ImportarInsumos extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    importando: false,
    progreso: { procesados: 0, total: null },
    archivosExcel: [],
    data: [],
    archivoError: null,
    todasFamilias: [],
    todasUnidades: [],
    todasImpuestos: [],
    todasRetenciones: [],
    todosMarcas: [],
    todosTiposDeInsumo: [],
    insumosExistentes: [],
    todasPrecios: [],
    proyectosAlmacen: [],
    ubicacionesProyecto: [],
  }

  componentDidMount() {
    // La importación corre en el servidor por lotes y avisa por WebSocket.
    this.seguidor = new SeguidorProcesoMasivo({
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      onProgreso: (progreso) => this.setState({ importando: true, progreso }),
      onFin: (resumen) => {
        this.setState({ importando: false, progreso: { procesados: 0, total: null } })
        // Sin resumen el proceso terminó pero no dejó números (murió, o caducó
        // su resultado): se cierra sin anunciar cifras inventadas.
        if (resumen) {
          message.success("Se importaron " + (resumen.numero ?? 0) + " insumos")
          if (resumen.repetidos) {
            message.warning("No se importaron " + resumen.repetidos + " insumos ya que estaban repetidos")
          }
        }
        this.atras()
      },
      onError: (error) => {
        this.setState({ importando: false, progreso: { procesados: 0, total: null } })
        message.error(error || "Hubo un error y los insumos no se importaron")
      },
    })
    this.seguidor.escuchar()

    this.setState({ loading: true })
    axios
      .post(
        "insumos/datosParaImportar",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({
            todasFamilias: res.data.familias,
            todasUnidades: res.data.unidades,
            todasImpuestos: res.data.impuestos,
            todasRetenciones: res.data.retenciones,
            todosCodigosSAT: res.data.subclases,
            todosMarcas: res.data.marcas,
            todosTiposDeInsumo: res.data.tiposDeInsumo,
            insumosExistentes: res.data.insumosExistentes,
            todasPrecios: res.data.precios,
            proyectosAlmacen: res.data.proyectosAlmacen || [],
            ubicacionesProyecto: res.data.ubicacionesProyecto || [],
            loading: false
          });
        } else {
          this.setState({ loading: false });
        }
      });
  }


  componentWillUnmount() {
    if (this.seguidor) this.seguidor.detener();
  }

  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    message.error("Revisa que los datos sean correctos");
  }

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "insumos/importarInsumos",
        { ...values, empresaId: this.props.empresaId, data: this.state.data, activo: this.props?.location?.state?.activo },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          // Arrancó. El avance y el cierre llegan por el seguidor.
          this.seguidor.seguir(res.data.procesoId);
          this.setState({
            importando: true,
            progreso: { procesados: 0, total: res.data.total ?? null },
          });
        } else if (res.data.success === 1) {
          message.error("No se pueden importar los insumos");
        } else {
          // Incluye el rechazo por candado: ya hay otra operación masiva en
          // curso para esta empresa.
          message.error(res.data.message || "Hubo un error y los insumos no se importaron");
        }
      });
  }

  async onChangeArchivo(e) {
    this.setState({ loading: true })
    if (e.file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.setState({ archivosExcel: [{ ...e.file, name: e.file.name, status: 'uploading', response: 'Cargando', }], arhcivo: e.file });
      this.cargarArchivoExcel(e.file)
    } else {
      message.error('El archivo debe ser un archivo de excel')
      this.setState({ loading: false })
    }
  }

  descargarArchivoErrores() {
    let wbout = XLSX.write(this.state.archivoError, { bookType: 'xlsx', type: 'binary' });
    const s2ab = (s) => {
      let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
      let view = new Uint8Array(buf);  //create uint8array as viewer
      for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
      return buf;
    }
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" })
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'errores.xlsx';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  cargarArchivoExcel(file) {
    let hojas = [];
    let reader = new FileReader()
    reader.readAsArrayBuffer(file)
    reader.onloadend = (e) => {
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, { type: 'array' })

      workbook.SheetNames.forEach((sheetName) => {
        let Xl_row_object = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName])
        hojas.push({
          data: Xl_row_object,
          sheetName
        })
      })
      let hoja1 = hojas[0].data
      this.archivoVerificar(hoja1).then((dataReturn) => {
        if (dataReturn.errores === 0) {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success' }], data: dataReturn.objeto });
        } else {
          this.setState({ archivosExcel: [{ ...file, name: file.name, status: 'success', response: 'Con errores', }], archivoError: dataReturn.archivoErrores, data: dataReturn.objeto });
          message.error('Se han detectado ' + dataReturn.errores + ' errores')
          message.info('Se se importan solo se importaran los campos correctos: ' + Number(hoja1.length - dataReturn.filaErrores))
        }
        this.setState({ loading: false })
      })
    }
  }

  async archivoVerificar(data) {
    let errores = 0
    let filaErrores = 0
    let mensaje = []
    const archivoEditar = XLSX.utils.book_new()
    const arrayErrores = []
    let objeto = []
    const clavesVistas = []
    const codigosBarrasVistos = []
    await Promise.all(data.map(async (data, index) => {
      let mensajeErrores = null
      let erroresFila = 0
      let fila = data['__rowNum__'] + 1
      let agregarInsumo = {}
      let impuestos = []
      let retenciones = []
      let clave = data['Clave'] ? `${data['Clave']}`.trim() : undefined
      let codigoBarras = data['Codigo Barras'] ? `${data['Codigo Barras']}`.trim() : undefined
      let descripcion = data['Descripcion'] ? `${data['Descripcion']}`.trim() : undefined
      let descripcionLarga = data['Descripcion Larga'] ? `${data['Descripcion Larga']}`.trim() : undefined
      let compra = data['Compra'] ? `${data['Compra']}`.trim() : undefined
      let venta = data['Venta'] ? `${data['Venta']}`.trim() : undefined
      let costo = data['Costo'] ? Number(data['Costo'].toString().replace(/\$\s?|(,*)/g, '')) : undefined
      let unidad = data['Unidad'] ? `${data['Unidad']}`.trim() : undefined
      let inventariable = data['Inventariable'] ? `${data['Inventariable']}`.trim() : undefined
      let lotesCaducidades = data['Lotes'] ? `${data['Lotes']}`.trim() : undefined
      let verInsumoVenta = data['Ver Insumo Venta'] ? `${data['Ver Insumo Venta']}`.trim() : undefined
      let leyenda = data['Leyenda'] ? `${data['Leyenda']}`.trim() : undefined
      let impuesto1 = data['Impuesto1'] ? `${data['Impuesto1']}`.trim() : undefined
      let impuesto2 = data['Impuesto2'] ? `${data['Impuesto2']}`.trim() : undefined
      let retencion1 = data['Retencion1'] ? `${data['Retencion1']}`.trim() : undefined
      let retencion2 = data['Retencion2'] ? `${data['Retencion2']}`.trim() : undefined
      let familia = data['Familia'] ? `${data['Familia']}`.trim() : undefined
      let codigoSat = data['Codigo SAT'] ? `${data['Codigo SAT']}`.trim() : undefined
      let marca = data['Marca'] ? `${data['Marca']}`.trim() : undefined
      let tipoDeInsumo = data['Tipo de Insumo'] ? `${data['Tipo de Insumo']}`.trim() : undefined
      const checarQueSeaNumero = (valor, nombreCampo) => {
        if (valor !== '' && valor !== undefined) {
          if (isNaN(valor) === true) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un numero`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un numero` : `${nombreCampo} no es un numero`
          }
        }
      }
      const queEste = (valor, nombreCampo) => {
        if (valor === '' || valor === undefined) {
          errores += 1
          erroresFila += 1
          mensaje.push(`${nombreCampo} fila: ${fila} esta vacio`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} esta vacio` : `${nombreCampo} esta vacio`
        }
      }
      const queSeaStringValido = (valor, nombreCampo) => {
        const patron = /^[\p{L}\p{N}\p{P}\p{S}\s]*$/u
        if (valor !== '' && valor !== undefined) {
          if (!patron.test(valor)) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${nombreCampo} fila: ${fila} no es un valor acceptado`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${nombreCampo} no es un valor acceptado` : `${nombreCampo} no es un valor acceptado`
          }
        }
      }
      const preciosArr = [];
      if (Array.isArray(this.state.todasPrecios)) {
        for (const nivel of this.state.todasPrecios) {
          const nombre = (nivel.nombre || '').trim();
          if (!nombre) continue;

          const keyPrecio = `Precio ${nombre}`;
          const precioLeido = data[keyPrecio] !== undefined
            ? Number(data[keyPrecio].toString().replace(/\$\s?|(,*)/g, ''))
            : undefined;

          if (data[keyPrecio] !== undefined && isNaN(precioLeido)) {
            errores += 1;
            erroresFila += 1;
            mensaje.push(`${keyPrecio} fila: ${fila} no es un número`);
            mensajeErrores = mensajeErrores
              ? `${mensajeErrores}, ${keyPrecio} no es un número`
              : `${keyPrecio} no es un número`;
            continue;
          }

          // Solo agregamos si realmente viene precio en el Excel
          if (precioLeido !== undefined) {
            preciosArr.push({
              precioId: nivel._id,
              precio: Number(precioLeido),
            });
          }
        }
      }
      queEste(clave, 'Clave')
      queEste(descripcion, 'Descripción')
      queEste(compra, 'Compra')
      queEste(venta, 'Venta')
      queEste(costo, 'Costo')
      queEste(unidad, 'Unidad')
      queEste(inventariable, 'Inventariable')
      queEste(familia, 'Familia')
      queSeaStringValido(clave, 'Clave')
      if (codigoBarras) {
        queSeaStringValido(codigoBarras, 'Codigo de Barras')
      }
      queSeaStringValido(descripcion, 'Descripción')
      queSeaStringValido(descripcionLarga, 'Descripción Larga')
      queSeaStringValido(compra, 'Compra')
      queSeaStringValido(venta, 'Venta')
      checarQueSeaNumero(costo, 'Costo')
      queSeaStringValido(unidad, 'Unidad')
      queSeaStringValido(inventariable, 'Inventariable')
      queSeaStringValido(lotesCaducidades, 'Lotes y Caducidades')
      queSeaStringValido(verInsumoVenta, 'Ver Insumo Venta')
      queSeaStringValido(leyenda, 'Leyenda')
      queSeaStringValido(impuesto1, 'Impuesto1')
      queSeaStringValido(impuesto2, 'Impuesto2')
      queSeaStringValido(retencion1, 'Retencion1')
      queSeaStringValido(retencion2, 'Retencion2')
      queSeaStringValido(codigoSat, 'Codigo SAT')
      queSeaStringValido(familia, 'Familia')
      queSeaStringValido(marca, 'Marca')
      queSeaStringValido(tipoDeInsumo, 'Tipo de Insumo')

      if (clave) {
        const claveRepetida = this.state.insumosExistentes.find((insumoT) => insumoT.clave === clave)
        if (claveRepetida || clavesVistas.includes(clave)) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Clave fila: ${fila} ya esta dada de alta`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Clave ya esta dada de alta` : `Clave ya esta dada de alta`
        } else {
          clavesVistas.push(clave)
        }
      }

      if (codigoBarras) {
        const codigoBarrasRepetido = this.state.insumosExistentes.find((insumoT) => insumoT.codigoBarras && insumoT.codigoBarras === codigoBarras)
        if (codigoBarrasRepetido || codigosBarrasVistos.includes(codigoBarras)) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Codigo Barras fila: ${fila} ya esta dado de alta`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Codigo Barras ya esta dado de alta` : `Codigo Barras ya esta dado de alta`
        } else {
          codigosBarrasVistos.push(codigoBarras)
        }
      }

      if (compra === 'SI' || compra === 'Si' || compra === 'si' || compra === 'Sí' || compra === 'sí' || compra === 'SÍ') {
        agregarInsumo.compra = true
      } else {
        agregarInsumo.compra = false
      }
      if (venta === 'SI' || venta === 'Si' || venta === 'si' || venta === 'Sí' || venta === 'sí' || venta === 'SÍ') {
        agregarInsumo.venta = true
      } else {
        agregarInsumo.venta = false
      }
      if (inventariable === 'SI' || inventariable === 'Si' || inventariable === 'si' || inventariable === 'Sí' || inventariable === 'sí' || inventariable === 'SÍ') {
        agregarInsumo.inventariable = true
      } else {
        agregarInsumo.inventariable = false
      }
      if (lotesCaducidades === 'SI' || lotesCaducidades === 'Si' || lotesCaducidades === 'si' || lotesCaducidades === 'Sí' || lotesCaducidades === 'sí' || lotesCaducidades === 'SÍ') {
        agregarInsumo.lotesCaducidades = true
      } else {
        agregarInsumo.lotesCaducidades = false
      }
      if (leyenda === 'SI' || leyenda === 'Si' || leyenda === 'si' || leyenda === 'Sí' || leyenda === 'sí' || leyenda === 'SÍ') {
        agregarInsumo.leyendaVenta = true
      } else {
        agregarInsumo.leyendaVenta = false
      }
      if (verInsumoVenta === 'SI' || verInsumoVenta === 'Si' || verInsumoVenta === 'si' || verInsumoVenta === 'Sí' || verInsumoVenta === 'sí' || verInsumoVenta === 'SÍ') {
        agregarInsumo.verInsumoVenta = true
      } else {
        agregarInsumo.verInsumoVenta = false
      }
      const unidadBuscar = this.state.todasUnidades.find((unidadT) => unidadT.nombre.trim() === unidad)

      if (!unidadBuscar) {
        errores += 1
        erroresFila += 1
        mensaje.push(`Unidad fila: ${fila} no es un valor aceptado`)
        mensajeErrores = mensajeErrores ? mensajeErrores + `, Unidad no es un valor de unidades` : `Unidad no es un valor de unidades`
      } else {
        agregarInsumo.unidadId = unidadBuscar._id
      }

      if (impuesto1) {
        const impuesto1Buscar = this.state.todasImpuestos.find((impuestoT) => impuestoT.nombre === impuesto1)
        if (!impuesto1Buscar) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Impuesto1 fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Impuesto1 no es un valor de impuestos` : `Impuesto1 no es un valor de impuestos`
        } else {
          agregarInsumo.impuesto1 = impuesto1Buscar._id
          impuestos.push({ impuestoId: impuesto1Buscar._id })
        }
      }

      if (impuesto2) {
        const impuesto2Buscar = this.state.todasImpuestos.find((impuestoT) => impuestoT.nombre === impuesto2)
        if (!impuesto2Buscar) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Impuesto2 fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Impuesto2 no es un valor de impuestos` : `Impuesto2 no es un valor de impuestos`
        } else {
          agregarInsumo.impuesto2 = impuesto2Buscar._id
          impuestos.push({ impuestoId: impuesto2Buscar._id })
        }
      }

      if (retencion1) {
        const retencion1Buscar = this.state.todasRetenciones.find((retencionT) => retencionT.nombre === retencion1)
        if (!retencion1Buscar) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Retencion1 fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Retencion1 no es un valor de retenciones` : `Retencion1 no es un valor de retenciones`
        } else {
          agregarInsumo.retencion1 = retencion1Buscar._id
          retenciones.push({ retencionId: retencion1Buscar._id })
        }
      }

      if (retencion2) {
        const retencion2Buscar = this.state.todasRetenciones.find((retencionT) => retencionT.nombre === retencion2)
        if (!retencion2Buscar) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Retencion2 fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Retencion2 no es un valor de retenciones` : `Retencion2 no es un valor de retenciones`
        } else {
          agregarInsumo.retencion2 = retencion2Buscar._id
          retenciones.push({ retencionId: retencion2Buscar._id })
        }
      }

      const familiaBuscar = this.state.todasFamilias.find((familiaT) => familiaT.nombre.trim() === familia)
      if (!familiaBuscar) {
        errores += 1
        erroresFila += 1
        mensaje.push(`Familia fila: ${fila} no es un valor aceptado`)
        mensajeErrores = mensajeErrores ? mensajeErrores + `, Familia no es un valor de familias` : `Familia no es un valor de familias`
      } else {
        agregarInsumo.familiaId = familiaBuscar._id
        agregarInsumo.familia = familiaBuscar.nombre
      }

      if (marca) {
        const marcaBuscar = this.state.todosMarcas.find((marcaT) => marcaT.nombre.trim() === marca)
        if (!marcaBuscar) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Marca fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Marca no es un valor de marcas` : `Marca no es un valor de marcas`
        } else {
          agregarInsumo.marcaId = marcaBuscar._id
          agregarInsumo.marca = marcaBuscar.nombre
        }
      }

      if (tipoDeInsumo) {
        const tipoDeInsumoBuscar = this.state.todosTiposDeInsumo.find((tipoT) => tipoT.nombre.trim() === tipoDeInsumo)
        if (!tipoDeInsumoBuscar) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Tipo de Insumo fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Tipo de Insumo no es un valor de tipos de insumo` : `Tipo de Insumo no es un valor de tipos de insumo`
        } else {
          agregarInsumo.tipoDeInsumoId = tipoDeInsumoBuscar._id
          agregarInsumo.tipoDeInsumo = tipoDeInsumoBuscar.nombre
        }
      }

      if (codigoSat) {
        const patron = /^\d{8}$/
        if (!patron.test(codigoSat)) {
          errores += 1
          erroresFila += 1
          mensaje.push(`Codigo SAT fila: ${fila} no es un valor aceptado`)
          mensajeErrores = mensajeErrores ? mensajeErrores + `, Codigo SAT no es un valor aceptado` : `Codigo SAT no es un valor aceptado`
        } else {

          const codigoSatBuscar = this.state.todosCodigosSAT.find((codigoT) => codigoT.c_ClaveProdServ === codigoSat)
          if (!codigoSatBuscar) {
            errores += 1
            erroresFila += 1
            mensaje.push(`Codigo SAT fila: ${fila} no es un valor aceptado`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, Codigo SAT no es un valor aceptado` : `Codigo SAT no es un valor aceptado`
          } else {
            agregarInsumo.codigoSatId = codigoSatBuscar._id
          }

          // const response = await axios.post(
          //   "codigoinsumos/buscarCodigo",
          //   { codigo: codigoSat },
          //   {
          //     headers: this.props.headersToken,
          //   }
          // )

          // if(response.data.status === 404){
          //   errores += 1
          //   erroresFila += 1
          //   mensaje.push(`Codigo SAT fila: ${fila} no es un valor aceptado`)
          //   mensajeErrores = mensajeErrores ? mensajeErrores + `, Codigo SAT no es un valor aceptado` : `Codigo SAT no es un valor aceptado`
          // }else{
          //   agregarInsumo.codigoSatId = response.data._id
          // }

        }
      }

      const ubicacionesPredeterminadas = []
      if (this.props.moduloWms) {
        for (const proyecto of this.state.proyectosAlmacen) {
          const nombreUbicacion = data[proyecto.nombre] ? `${data[proyecto.nombre]}`.trim() : undefined
          if (!nombreUbicacion) continue
          const ubicacionBuscar = this.state.ubicacionesProyecto.find(
            (u) => u.proyectoId.toString() === proyecto._id.toString() && u.nombre.trim().toLowerCase() === nombreUbicacion.toLowerCase()
          )
          if (!ubicacionBuscar) {
            errores += 1
            erroresFila += 1
            mensaje.push(`${proyecto.nombre} fila: ${fila} no es una ubicación válida de ese almacén`)
            mensajeErrores = mensajeErrores ? mensajeErrores + `, ${proyecto.nombre} no es una ubicación válida` : `${proyecto.nombre} no es una ubicación válida`
          } else {
            ubicacionesPredeterminadas.push({ proyectoId: proyecto._id, ubicacionId: ubicacionBuscar._id })
          }
        }
      }

      if (erroresFila === 0) {
        objeto.push({
          clave: clave,
          codigoBarras: codigoBarras,
          descripcion: descripcion,
          descripcionLarga: descripcionLarga,
          compra: compra,
          venta: venta,
          costo: costo,
          unidad: unidad,
          leyenda: leyenda,
          impuesto1: impuesto1,
          impuesto2: impuesto2,
          retencion1: retencion1,
          retencion2: retencion2,
          familia: familia,
          codigoSat: codigoSat,
          ...agregarInsumo,
          impuestos: impuestos,
          retenciones: retenciones,
          precios: preciosArr,
          ...(this.props.moduloWms ? { ubicacionesPredeterminadas } : {}),
        })
      } else {
        arrayErrores.push({
          'Errores': mensajeErrores,
          'Fila archivo inicial': fila,
          ...data,
        })
        filaErrores += 1
      }
      return null
    }))
    const hoja = XLSX.utils.json_to_sheet(arrayErrores)
    XLSX.utils.book_append_sheet(archivoEditar, hoja, 'Hoja Errores')
    return { objeto: objeto, errores: errores, filaErrores, mensaje: mensaje, archivoErrores: archivoEditar }
  }

  async descargarPlantillaImportar() {
    const response = await fetch('/plantillaInsumos.xlsx'); // asegúrate de que esté en la carpeta "public"
    const data = await response.arrayBuffer(); // lo convertimos en un arrayBuffer

    let plantillaXlsx = XLSX.read(data, { type: "array" });

    // 👉 Obtener la primera hoja
    const nombrePrimeraHoja = plantillaXlsx.SheetNames[0];
    const hoja = plantillaXlsx.Sheets[nombrePrimeraHoja];

    // 👉 Convertir a JSON para manipular columnas
    let datos = XLSX.utils.sheet_to_json(hoja, { defval: "" });

    // 👉 Insertar columnas nuevas después de "Costo"
    const nuevasColumnas = this.state.todasPrecios.map((precio) => "Precio " + precio.nombre);

    datos = datos.map((fila) => {
      const nuevaFila = {};
      for (const key in fila) {
        nuevaFila[key] = fila[key];
        if (key === "Costo") {
          nuevasColumnas.forEach((col) => {
            nuevaFila[col] = ""; // valor vacío por defecto
          });
        }
        if (key === "Marca") {
          nuevaFila["Tipo de Insumo"] = ""; // valor vacío por defecto
          if (this.props.moduloWms) {
            this.state.proyectosAlmacen.forEach((proyecto) => {
              nuevaFila[proyecto.nombre] = ""; // ubicación predeterminada para ese almacén, vacío por defecto
            });
          }
        }
      }
      return nuevaFila;
    });

    // 👉 Convertir de nuevo a hoja
    const nuevaHojaInicial = XLSX.utils.json_to_sheet(datos);

    // Reemplazar la primera hoja en el workbook
    plantillaXlsx.Sheets[nombrePrimeraHoja] = nuevaHojaInicial;

    // Crear una nueva hoja con dato
    const hojaFamilias = this.state.todasFamilias.map((familia) => {
      return {
        "Nombre": familia.nombre,
        "Descripcion": familia.descripcion,
      }
    })

    const nuevaHojaFamilias = XLSX.utils.json_to_sheet(hojaFamilias);

    // Agregar la nueva hoja al workbook
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaFamilias, "Familias");

    // Crear una nueva hoja con dato
    const hojaUnidades = this.state.todasUnidades.map((unidad) => {
      return {
        "Nombre": unidad.nombre,
        "Descripcion": unidad.descripcion,
        "Unidad SAT": unidad.unidadSat.c_ClaveUnidad
      }
    })

    const nuevaHojaUnidades = XLSX.utils.json_to_sheet(hojaUnidades);

    // Agregar la nueva hoja al workbook
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaUnidades, "Unidades");

    // Crear una nueva hoja con dato
    const hojaImpuestos = this.state.todasImpuestos.map((impuesto) => {
      return {
        "Nombre": impuesto.nombre
      }
    })

    const nuevaHojaImpuestos = XLSX.utils.json_to_sheet(hojaImpuestos);

    // Agregar la nueva hoja al workbook
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaImpuestos, "Impuestos");

    // Crear una nueva hoja con dato
    const hojaRetenciones = this.state.todasRetenciones.map((retencion) => {
      return {
        "Nombre": retencion.nombre,
      }
    })

    const nuevaHojaRetenciones = XLSX.utils.json_to_sheet(hojaRetenciones);

    // Agregar la nueva hoja al workbook
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaRetenciones, "Retenciones");

    // Crear una nueva hoja con dato
    const hojaMarcas = this.state.todosMarcas.map((marca) => {
      return {
        "Nombre": marca.nombre,
      }
    })

    const nuevaHojaMarcas = XLSX.utils.json_to_sheet(hojaMarcas);

    // Agregar la nueva hoja al workbook
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaMarcas, "Marcas");

    // Crear una nueva hoja con dato
    const hojaTiposDeInsumo = this.state.todosTiposDeInsumo.map((tipoDeInsumo) => {
      return {
        "Nombre": tipoDeInsumo.nombre,
      }
    })

    const nuevaHojaTiposDeInsumo = XLSX.utils.json_to_sheet(hojaTiposDeInsumo);

    // Agregar la nueva hoja al workbook
    XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaTiposDeInsumo, "Tipos de Insumo");

    if (this.props.moduloWms) {
      // Crear una hoja de referencia con las ubicaciones válidas por almacén
      const hojaUbicaciones = this.state.ubicacionesProyecto.map((ubicacion) => {
        const proyecto = this.state.proyectosAlmacen.find((p) => p._id.toString() === ubicacion.proyectoId.toString());
        return {
          "Almacén": proyecto?.nombre || "",
          "Ubicación": ubicacion.nombre,
          "Clave": ubicacion.clave,
        }
      })

      const nuevaHojaUbicaciones = XLSX.utils.json_to_sheet(hojaUbicaciones.length > 0 ? hojaUbicaciones : [{ "Almacén": "(sin ubicaciones registradas)" }]);

      // Agregar la nueva hoja al workbook
      XLSX.utils.book_append_sheet(plantillaXlsx, nuevaHojaUbicaciones, "Ubicaciones");
    }

    // Guardar el archivo modificado
    XLSX.writeFile(plantillaXlsx, "plantillaInsumos.xlsx");

  }

  render() {
    const precioColumns = (this.state.todasPrecios || []).map((nivel) => ({
      title: `Precio ${nivel.nombre}`,
      key: `precio_${nivel._id}`,
      render: (_, record) => {
        const p = (record.precios || []).find((x) => String(x.precioId) === String(nivel._id));
        return p !== undefined ? `$${p.precio}` : '-';
      },
    }));

    const ubicacionColumns = this.props.moduloWms
      ? this.state.proyectosAlmacen.map((proyecto) => ({
        title: proyecto.nombre,
        key: `ubicacion_${proyecto._id}`,
        width: 140,
        render: (_, record) => {
          const entrada = (record.ubicacionesPredeterminadas || []).find(
            (u) => u.proyectoId.toString() === proyecto._id.toString()
          );
          if (!entrada) return '-';
          const ubicacion = this.state.ubicacionesProyecto.find((u) => u._id.toString() === entrada.ubicacionId.toString());
          return ubicacion?.nombre || '-';
        },
      }))
      : [];

    const columns = [
      {
        title: "Clave",
        dataIndex: "clave",
        key: "clave",
        fixed: "left",
        width: 100,
        sorter: (a, b) => (a.clave < b.clave ? -1 : a.clave > b.clave ? 1 : 0),
        buscar: "clave",
      },
      {
        title: "Código Barras",
        dataIndex: "codigoBarras",
        key: "codigoBarras",
        width: 130,
      },
      {
        title: "Descripción",
        dataIndex: "descripcion",
        key: "descripcion",
        width: 180,
        sorter: (a, b) => (a.descripcion < b.descripcion ? -1 : a.descripcion > b.descripcion ? 1 : 0),
        buscar: "descripcion",
      },
      {
        title: "Descripción Larga",
        dataIndex: "descripcionLarga",
        key: "descripcionLarga",
        width: 180,
      },
      {
        title: "Familia",
        dataIndex: "familia",
        key: "familia",
        width: 120,
        sorter: (a, b) => (a.familia < b.familia ? -1 : a.familia > b.familia ? 1 : 0),
        buscar: "familia",
      },
      {
        title: "Marca",
        dataIndex: "marca",
        key: "marca",
        width: 110,
      },
      {
        title: "Tipo de Insumo",
        dataIndex: "tipoDeInsumo",
        key: "tipoDeInsumo",
        width: 130,
        render: (v) => v || '-',
      },
      {
        title: "Unidad",
        dataIndex: "unidad",
        key: "unidad",
        width: 90,
      },
      {
        title: "Costo",
        dataIndex: "costo",
        key: "costo",
        width: 90,
        render: (v) => (v !== undefined ? `$${v}` : '-'),
      },
      ...precioColumns,
      {
        title: "Compra",
        dataIndex: "compra",
        key: "compra",
        width: 80,
        render: (v) => (v === true || v === 'SI' || v === 'si' || v === 'Sí' ? 'SI' : 'NO'),
      },
      {
        title: "Venta",
        dataIndex: "venta",
        key: "venta",
        width: 80,
        render: (v) => (v === true || v === 'SI' || v === 'si' || v === 'Sí' ? 'SI' : 'NO'),
      },
      {
        title: "Inventariable",
        dataIndex: "inventariable",
        key: "inventariable",
        width: 110,
        render: (v) => (v ? 'SI' : 'NO'),
      },
      {
        title: "Lotes/Caducidades",
        dataIndex: "lotesCaducidades",
        key: "lotesCaducidades",
        width: 150,
        render: (v) => (v ? 'SI' : 'NO'),
      },
      {
        title: "Ver en Venta",
        dataIndex: "verInsumoVenta",
        key: "verInsumoVenta",
        width: 110,
        render: (v) => (v ? 'SI' : 'NO'),
      },
      {
        title: "Leyenda",
        dataIndex: "leyendaVenta",
        key: "leyendaVenta",
        width: 90,
        render: (v) => (v ? 'SI' : 'NO'),
      },
      {
        title: "Impuesto 1",
        dataIndex: "impuesto1",
        key: "impuesto1",
        width: 110,
        render: (v) => v || '-',
      },
      {
        title: "Impuesto 2",
        dataIndex: "impuesto2",
        key: "impuesto2",
        width: 110,
        render: (v) => v || '-',
      },
      {
        title: "Retención 1",
        dataIndex: "retencion1",
        key: "retencion1",
        width: 110,
        render: (v) => v || '-',
      },
      {
        title: "Retención 2",
        dataIndex: "retencion2",
        key: "retencion2",
        width: 110,
        render: (v) => v || '-',
      },
      {
        title: "Código SAT",
        dataIndex: "codigoSat",
        key: "codigoSat",
        width: 110,
        render: (v) => v || '-',
      },
      ...ubicacionColumns,
    ];
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={this.props?.location?.state?.activo ? `Importar ${this.props.taxidermia ? "Formas" : "Activos"}` : "Importar Insumos"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={this.state.archivoError ? <ButtonItem onClick={this.descargarArchivoErrores.bind(this)}>Descargar Errores</ButtonItem> : null}
        />
        <div className="card-background" style={{ paddingTop: 5 }}>
          <Spin spinning={this.state.loading} tip="Cargando valores, espere por favor">
            <Form
              ref={this.formRef}
              name="importarInsumos"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Importar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Row style={{ marginTop: 20 }}>
                <Col span={12} xs={24} sm={24} lg={12} xl={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <ButtonItem onClick={() => this.descargarPlantillaImportar()} type="primary">Descargar Plantilla</ButtonItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem name="archivo" label="Archivo">
                    <Upload
                      showUploadList={{
                        showRemoveIcon: false,
                        showPreviewIcon: false,
                      }}
                      fileList={this.state.archivosExcel}
                      customRequest={this.onChangeArchivo.bind(this)}
                      accept='.xlsx'
                    >
                      <ButtonItem icon={<UploadOutlined />}>Subir</ButtonItem>
                    </Upload>
                  </FormItem>
                </Col>
              </Row>
            </Form>
            <TableItem
              size="small"
              dataSource={this.state.data}
              columns={columns}
              scroll={{ x: 'max-content' }}
            />
          </Spin>
        </div>
        <ModalProgreso
          visible={this.state.importando}
          titulo="Importando insumos"
          descripcion="No cierres esta ventana: el proceso sigue en el servidor, pero perderías el avance en pantalla. Los insumos se crean por lotes para no saturar la base."
          procesados={this.state.progreso.procesados}
          total={this.state.progreso.total}
          unidad="insumos"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    taxidermia: state.empresa.taxidermia,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(ImportarInsumos);
